// CORE
import { executeRequest, type ApiResult } from '@/core/either';
import { http } from '@/core/api';

// TYPES
import type { IPurposeList } from '@/shared/onboardingForms/types/companyPurposes.type';

export const purposeService = {
  /**
   * Obtiene la lista de propósitos de exportación por código de país.
   * @param countryCode - Código del país (ej: 'CO', 'US', etc.).
   * @returns Promesa con el resultado tipado usando Either (ApiResult<IPurposeList[]>).
   */
  getExportPurposes(countryCode: string): Promise<ApiResult<IPurposeList[]>> {
    return executeRequest(() =>
      http.get<IPurposeList[]>(`company/b2b/purpose/active-purposes/${countryCode}`)
    );
  },
};
